import feathersClient, { makeServicePlugin, BaseModel } from '@/api-client'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)
class Kit extends BaseModel {
  static modelName = 'Kit'
}
const servicePath = 'kits'
const servicePlugin = makeServicePlugin({
  Model: Kit,
  // IMPORTANT
  whitelist: [
    '$eager',
    '$iRegexp',
    '$regex',
    '$options',
    '$mergeEager',
    '$or',
    '$and',
    '$modifiers',
    '$select',
    '$joinRelation',
    '$relation'
  ],
  // Update the allowEager to include all needed relations
  allowEager: 'shop,shop.mso,mso',
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
